import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { apiGet } from "../api/api";

export default function ProjetoDetalhes() {
  const { id } = useParams();
  const [projeto, setProjeto] = useState(null);

  useEffect(() => {
    apiGet(`/projetos/${id}/`).then(setProjeto);
  }, [id]);

  if (!projeto) return <p>A carregar...</p>;

  return (
    <div style={{ padding: 20 }}>
      <h1>{projeto.nome}</h1>
      <p>Cliente: {projeto.cliente}</p>

      <Link to={`/projetos/${id}/locais/novo`}>
        <button>Adicionar Local</button>
      </Link>

      <h2>Locais</h2>
      <ul>
        {projeto.locais.map((l) => (
          <li key={l.id}>
            <strong>{l.mupi_id}</strong>
            <br />
            {l.latitude}, {l.longitude}
            <br />
            <Link to={`/auditar/${l.id}`}>
              <button>Auditar</button>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
